import * as React from 'react';
import type { ReactNode } from 'react';
import type { SectionWithAnchorViewModel } from './SectionWithAnchorViewModel.csharp';

type RenderFunction<T> = (props: T) => ReactNode;

interface SectionWithAnchorProps<T> {
    section: SectionWithAnchorViewModel<T>;
    renderContent: RenderFunction<T>;
}

export const SectionWithAnchor = <T,>(props: SectionWithAnchorProps<T>) => {
    const { section, renderContent } = props;
    const { id, shouldBeShown, content } = section;

    return <>{shouldBeShown && <div id={id}>{renderContent(content)}</div>}</>;
};
